import browse_car from '../assets/images/browse-car.png';
import fill_info from '../assets/images/fill-info.png';
import subscription from '../assets/images/subscription.png';
import buy from '../assets/images/buy.png';
import accent from '../assets/images/vehicles/Accent_Fix.png';
import rush from '../assets/images/vehicles/rush.png';
import hyundaicreta from '../assets/images/vehicles/Hyundai_Creta_Fix.png';
import hyundaitucson from '../assets/images/vehicles/Hyundai_Tucson_View1_Fix.png';
import ertiga from '../assets/images/vehicles/Ertiga_Fix.png';
import everestTrend from '../assets/images/vehicles/Ford-Everest-Trend.png';
import majesty from '../assets/images/vehicles/Majesty.png';
import toyotafortuna from '../assets/images/vehicles/Toyota_Fortuna_Fix.png';
import optima from '../assets/images/vehicles/Optima.png';

const how_it_works = [
    {
        title: '1 - Sign up',
        description: 'Take a few minutes to create a free account.',
        image: fill_info,
    },
    {
        title: '2 - Find your car & Get quote.',
        description:
            'Browse our wide range of vehicles from the brands we offer and get instant online quotes by choosing duration and estimate kilometer usage per month.',
        image: browse_car,
    },
    {
        title: '3 - Verification',
        description:
            'Once you’ve found a perfect car, submit signed Credit Application along with required documents through online. Application result will be informed within 48 hours via email.',
        image: subscription,
    },
    {
        title: '4 - Sign Contract and Make Payment',
        description:
            'Once application is approved, you will be notified of a date to sign the contract and delivery of a car. The payment is one month’s lease payment in advance.',
        image: browse_car,
    },
    {
        title: '5 - Enjoy Your Drive',
        description: 'Meet your brand-new car at delivery to your home or your office & enjoy your car!.',
        image: buy,
    },
];

const fleet = [
    {
        name: 'Suzuki Ertiga',
        image: ertiga,
    },
    {
        name: 'Toyota Majesty',
        image: majesty,
    },
    {
        name: 'Ford Everest Trend',
        image: everestTrend,
    },
    {
        name: 'KIA Optima',
        image: optima,
    },
    {
        name: 'Hyundai Creta',
        image: hyundaicreta,
    },
    {
        name: 'Hyundai Tucson',
        image: hyundaitucson,
    },
    {
        name: 'Hyundai Accent',
        image: accent,
    },
    {
        name: 'Toyota Rush',
        image: rush,
    },
    {
        name: 'Toyota Fortuna',
        image: toyotafortuna,
    },
];

export { how_it_works, fleet };
